export default {
  SESSION_TIME: 'Session Time',
  LOCAL_TIME: 'Local Time',
};
